<template>
    <popup-window ref="ppModal" :title="currentAction ? currentAction.Title : ''" width="50%" :modal="true">

        <div ref="ppContent" class="first-launch-content" style="height: 400px;"></div>

        <button type="button" class="btn btn-action-close" @click="onActionClose">Закрыть</button>

    </popup-window>
</template>

<script>
    // import $ from 'jquery'

    export default {
        name: "first-launch",

        props: ['firstLaunchItems'],

        data(){
            return {
                currentAction: null,
                index: 0
            }
        },

        methods: {
            showNextAction() {
                this.currentAction = this.firstLaunchItems[this.index];
                if (this.currentAction.ActionTypeId === 1) {
                    this.$refs['ppModal'].show();
                    this.setPdfContent(this.currentAction.FileName);
                }
            },

            setPdfContent(fileName) {
                let vm = this;

                vm.$nextTick(() => {
                    vm.$refs.ppContent.innerHTML =
                        '<object type="application/pdf" data="' + fileName + '" width="100%" height="100%">' +
                    '<p>Ваш браузер не может открыть PDF. Возможно у Вас отсутствует Adobe Reader или браузер не поддерживает просмотр PDF. <a :href="' + fileName + '">Нажмите здесь, чтобы скачать</a></p>' +
                    '</object>';
                });
            },

            // клик по закрытию текущего окна
            onActionClose(){
                if(this.firstLaunchItems.length - 1 > this.index){
                    this.index ++;
                    this.showNextAction();
                }else {
                    // все окна просмотрены
                    this.$refs['ppModal'].close();
                    this.$emit('actions-complete');
                }
            }
        },

        mounted(){
            let vm = this;

            if(vm.firstLaunchItems && vm.firstLaunchItems.length) {

                vm.showNextAction();

            }
        }
    }
</script>

<style scoped>
    .btn.btn-action-close{
        margin:10px auto 0 auto;
    }
</style>


// WEBPACK FOOTER //
// Content/src/components/FirstLaunch.vue